// 单规格列表
export default {
    heard_title: "项目订单列表",
    heard_btn: "创建单项目订单",
    heard_btn2: "创建包场订单",

    tb_editPlayer: "编辑选手",
    tb_close: "关闭",
    tb_print: "打印小票",
    // 关闭订单
    dt_closeOrder: "关闭订单",
    dp_memo: "请输入备注内容",
    // 编辑选手弹出框
    dt_editPlayer: "添加选手",
    d_date: "日期场次",
    d_project: "项目",
    d_playerName: "选手",
    // 未完成提示框
    dt_noSuccess: "未完成",
    dt_message: "还有选手未输入,是否确认添加完成",
    // 打印提示
    dt_noPlayer: "未完成",
    dt_message2: "还有选手未输入,是否打印",
    // 退款相关
    confirm_title: "此操作将直接退款到账, 是否继续?",
    sm_refundSubmit: "退款提交成功",
    em_refundSubmit: "退款提交出错",
    im_refundSubmit: "已取消退款",
    // 打印
    sm_print: "打印成功",
    em_print: "打印失败"
};
